/**************************************************
 * Nombre:       Home_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {ApartmentOutlined, CallOutlined, MailOutline} from '@mui/icons-material'
import IconoTexto from "./SubComponentes/IconoTexto";
import {REDES} from "../../../Constantes";
import {irUrl} from "../../../Utilidades/irUrl";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Contactos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{color: theme.palette.primary.main, fontSize: 32, fontWeight: 800}}
                                    >Contactos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 7}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography
                                        sx={{fontSize: 16, fontWeight: 300}}
                                    >Estamos aquí para ayudarte con tus dudas y brindarte la mejor atención en todo
                                        momento.</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>


                                        {contactos.map((it, index) => {
                                            return (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                                    <IconoTexto Icono={it.icono} texto={it.texto}/>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 7}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-end'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        {REDES.map((it, index) => {
                                            return (
                                                <Grid
                                                    onClick={() => irUrl(it.url)}
                                                    container size={{xs: 2, sm: 2, md: 2}}
                                                    sx={{justifyContent: 'flex-start', cursor: 'pointer'}}>
                                                    <it.icono
                                                        sx={{fill: theme.palette.primary.main, width: 40, height: 40}}/>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6383.572077327796!2d-81.7089028300245!3d12.583743664497142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f05a6080ad415dd%3A0x4713d8638d135ba6!2sOver%20Receptour!5e0!3m2!1ses!2sco!4v1715877288216!5m2!1ses!2sco"

                                style={{border: 0, width: sCell ? '100%' : '90%', height: 400}} allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Contactos

const contactos = [
    {
        icono: ApartmentOutlined,
        texto: 'Oficina Principal: Cra 9A #10-156 Swamp Ground'
    },
    {
        icono: MailOutline,
        texto: 'reservas@receptourdelcaribe.com'
    },
    {
        icono: MailOutline,
        texto: 'info@receptourdelcaribe.com'
    },
    {
        icono: CallOutlined,
        texto: 'Reservas: 608 740 5885 – 740 5886'
    },

]